<template>
<div id="app">
	<template v-if="!currentRoute.includes('manual')">
		<app-header />
		<navigation />
	</template>
	<router-view :key="($route.params.hasOwnProperty('id') ? $route.params.id : 'key')"/>
</div>
</template>

<script>
//TODO: lade pdfMake und jszip asnychron, wenn es benötigt wird -> oder erstelle eine server funktionalität dafür
//import pdfMake from "pdfmake/build/pdfmake.min";
//import pdfFonts from "pdfmake/build/vfs_fonts";
//pdfMake.vfs = pdfFonts.pdfMake.vfs;

import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import "@/../static/font-awesome/css/font-awesome.min.css"
import "@/css/style.css"
import "@/css/button.css"
import "datatables.net/js/jquery.dataTables.min"
import "datatables.net-bs/css/dataTables.bootstrap.min.css"
import "datatables.net-bs/js/dataTables.bootstrap.min.js"
import "datatables.net-buttons"
import "datatables.net-buttons-bs/css/buttons.bootstrap.min.css"
import "datatables.net-buttons-bs/js/buttons.bootstrap.min.js"
import "datatables.net-buttons/js/buttons.print.js"
import "datatables.net-buttons/js/buttons.html5.js"
import 'datatables.net-buttons/js/buttons.colVis.js'
import 'datatables.net-colreorder-bs/css/colReorder.bootstrap.min.css'
import 'datatables.net-colreorder-bs/js/colReorder.bootstrap.min.js'
import 'datatables.net-keytable-bs/css/keyTable.bootstrap.min.css'
import 'datatables.net-keytable-bs/js/keyTable.bootstrap.min.js'
import 'datatables.net-fixedcolumns-bs/css/fixedColumns.bootstrap.min.css'
import 'datatables.net-fixedcolumns-bs/js/fixedColumns.bootstrap.min.js'

import 'datatables.net-rowgroup-bs/css/rowGroup.bootstrap.min.css'
import 'datatables.net-rowgroup-bs/js/rowGroup.bootstrap.min.js'

import jszip from "jszip/dist/jszip.min"
window.JSZip = jszip;


export default {
  name: "App",
  components: {
	  "navigation": () => import('@/components/design/Navigation.vue'),
	  "app-header": () => import('@/components/design/Header.vue'),
  },
  computed: {
	currentRoute() {
		return this.$route.path;
	}
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/App.vue